import { BoundaryErrorMessage } from 'reducers/errorReducer';

export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';

export const errorMessage = (error: BoundaryErrorMessage) => ({
  type: ERROR_MESSAGE,
  errorInfo: error,
});
